import { render } from "./ProfileItem.vue?vue&type=template&id=296f4a6e"
import script from "./ProfileItem.vue?vue&type=script&lang=js"
export * from "./ProfileItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__